module.exports = __webpack_public_path__ + "img/nav2.a3bd3df0.png";